import React from 'react';
import {appText} from '../../../assets/text/appText';
import './styles.css';

interface Props {
  onChange: (text: string) => void;
  value: string;
  className?: string;
  onEnter?: (text: string) => void;
}

const SearchInput = React.memo(
  ({onChange, value, className, onEnter}: Props) => {
    return (
      <div className={`SearchInputOuterContainer ${className}`}>
        <div className={`SearchInputContainer ${className}`}>
          {value ? (
            <span
              className="icon-x-circle ClearIcon"
              onClick={e => {
                e.stopPropagation();
                onChange('');
              }}></span>
          ) : (
            <span className="icon-search-lg"></span>
          )}
          <input
            placeholder={appText.search}
            value={value}
            onClick={e => e.stopPropagation()}
            onChange={e => onChange((e.target as HTMLInputElement).value)}
            onKeyDown={e => {
              if (e.key === 'Enter' && onEnter) {
                onEnter((e.target as HTMLInputElement).value);
              }
            }}
          />
        </div>
      </div>
    );
  },
);

export default SearchInput;
